import { NavigationView } from "./navigation.state";

/**
 * Derive the navigation view + active tab from a URL synchronously.
 * Shared by the side-nav (for its initial value on bootstrap) and the
 * router-event effect (for runtime updates after every NavigationEnd).
 */
export function parseNavigationUrl(url: string): { view: NavigationView; activeTab: string | null } {
    const cleanUrl = url.split("?")[0];

    // Quote detail: /:companyId/quote/:quoteId/...
    const quoteMatch = cleanUrl.match(/^\/\d+\/quote\/(\d+)(?:\/(.+))?$/);
    if (quoteMatch) {
        const isListPage = /^\/\d+\/quote\/(create|review-multiple|create-subscription)/.test(cleanUrl);
        if (!isListPage) {
            const tabSlug = quoteMatch[2]?.split("/")[0] || null;
            return { view: "quote-page", activeTab: tabSlug };
        }
    }

    // Customer detail: /:companyId/customer/:customerId/...
    const customerMatch = cleanUrl.match(/^\/\d+\/customer\/([^/]+)(?:\/(.+))?$/);
    if (customerMatch) {
        const isListPage = /^\/\d+\/customer\/(create|list)?$/.test(cleanUrl);
        if (!isListPage) {
            const tabSlug = customerMatch[2]?.split("/")[0] || null;
            return { view: "customer-page", activeTab: tabSlug };
        }
    }

    // Contact detail: /:companyId/contact/:contactId/...
    const contactMatch = cleanUrl.match(/^\/\d+\/contact\/(\d+)(?:\/(.+))?$/);
    if (contactMatch) {
        const isListPage = /^\/\d+\/contact\/(create)?$/.test(cleanUrl);
        if (!isListPage) {
            const tabSlug = contactMatch[2]?.split("/")[0] || null;
            return { view: "contact-page", activeTab: tabSlug };
        }
    }

    // Contract detail: /:companyId/contract/:contractId/...
    const contractMatch = cleanUrl.match(/^\/\d+\/contract\/(\d+)(?:\/(.+))?$/);
    if (contractMatch) {
        const tabSlug = contractMatch[2]?.split("/")[0] || null;
        return { view: "contract-page", activeTab: tabSlug };
    }

    return { view: "main", activeTab: null };
}
